import {
  Tooltip,
  IconButton,
  ClickAwayListener,
  useMediaQuery,
} from "@mui/material";
import { useEffect } from "react";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

const AUTO_CLOSE_TIME = 3000;

const TOOLTIP_ICONS = {
  filled: InfoIcon,
  outlined: InfoOutlinedIcon,
  rounded: InfoRoundedIcon,
};

const CustomTooltip = ({
  id,
  title,
  openTooltipId,
  setOpenTooltipId,
  iconVariant = "filled",
  iconSize = 20,
  placement = "bottom",
  sx,
  arrow = true,
  tooltipProps = {},
}) => {
  const isTouchDevice = useMediaQuery("(pointer: coarse)");

  const isOpen = openTooltipId === id;
  const IconComponent = TOOLTIP_ICONS[iconVariant] || TOOLTIP_ICONS.outlined;

  useEffect(() => {
    if (isTouchDevice && isOpen) {
      const timer = setTimeout(() => setOpenTooltipId(null), AUTO_CLOSE_TIME);
      return () => clearTimeout(timer);
    }
  }, [isTouchDevice, isOpen, setOpenTooltipId]);

  return (
    <ClickAwayListener
      onClickAway={() => isTouchDevice && setOpenTooltipId(null)}
    >
      <div style={{ display: "inline-block" }}>
          <Tooltip
            key={isTouchDevice ? "mobile" : "desktop"}
            title={title}
            placement={placement}
            arrow={arrow}
            sx={sx}
            open={isTouchDevice ? isOpen : undefined}
            disableHoverListener={isTouchDevice}
            disableFocusListener={isTouchDevice}
            disableTouchListener={isTouchDevice}
            {...tooltipProps}
          >
          <IconButton
            sx={{ fontSize: iconSize }}
            onClick={(e) => {
              if (isTouchDevice) {
                e.stopPropagation();
                setOpenTooltipId(isOpen ? null : id);
              }
            }}
          >
            <IconComponent sx={{ fontSize: iconSize }} />
          </IconButton>
        </Tooltip>
      </div>
    </ClickAwayListener>
  );
};

export default CustomTooltip;
